import { render, staticRenderFns } from "./buildingDetail.vue?vue&type=template&id=46522c63&"
import script from "./buildingDetail.vue?vue&type=script&lang=js&"
export * from "./buildingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports